import { useContext } from "react"
import { AppContext } from "../App"
import { MdChevronLeft, MdChevronRight, MdLogout, MdMenu, MdNotifications, MdOutlineMessage, MdOutlineNotifications, MdOutlineShoppingCartCheckout } from "react-icons/md";
import { IoChevronBack, IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots } from "react-icons/tb";
import { callApi, setCookie } from "../Helpers";
import logo_worded_only from '../assets/logo_worded_only.png';
import { AiOutlineBell, AiOutlineUser } from 'react-icons/ai';

export default function TopBar(props) {

  const appContext = useContext(AppContext);

  return (
    <div
      className="TopBar"
    >
      <div
        className="container d-flex justify-content-between"
        style={{
          height: "100%",
        }}
      >


        <h1
          className="mIcon font-bold text-start flex-grow-1 mNoMargin align-self-center text-secondary mOneLineText d-flex"
          style={{
            
            fontSize: "24px"
          }}
        >
          {
            ((appContext.navItem && appContext.navItem !== 'home') || appContext.navSubItem) ?
            <MdChevronLeft 
              size={36} 
              className="align-self-center"
              onClick={appContext.navBack}
            />
            :
            <span
              style={{
                paddingLeft: "10px",
              }}
            >

            </span>
          }
          <span 
            className="align-self-center"
            style={{
              paddingLeft: "0",
            }}
          >
            Afya Mingle
          </span>
        </h1>

        <div
          className="mIcon text-center"
          onClick={() => {
            appContext.navTo({
              item: 'view',
              subItem: 'pharmacy-cart',
            })
          }}
        >
          <MdOutlineShoppingCartCheckout
            className="mSymbol"
          />
          {
            (appContext.cart && appContext.cart.length > 0) ?
            <span className="mBadge">{appContext.cart.length}</span>
            :""
          }
          
        </div>

        <div
          className="mIcon text-center"
        >
          <AiOutlineBell
            className="mSymbol"
            onClick={() => {
              appContext.navTo({
                item: 'notifications',
              })
            }}
          />
        </div>

        <div
          className="mIcon text-center"
        >
          <AiOutlineUser
            className="mSymbol"
            onClick={() => {
              appContext.navTo({
                item: 'account',
              })
            }}
          />
        </div>

      </div>
    </div>
  )
}